import React from 'react'
import Headersection from '../components/Headersection'
import TipTrick from '../components/TipTrick'

const Runway = () => {
  return (
    <>

      <Headersection title="Paper Airplane Tips" information="The runway is where you can find a bunch of tips, tricks and ideas for maximizing the performance of your paper airplanes. Discover what works best and learn how to become a pro." />
      <TipTrick />
    </>
  )
}

export default Runway